import dayjs from 'dayjs';
import HeapUtils from 'app/utils/heap';

export const CHECKLIST_TRACKING_IDS: Record<string, string> = {
  'connect-profiles': 'connect_profiles',
  'create-first-post': 'first_post',
  'send-post-for-approval': 'send_for_approval',
  'invite-teammate': 'invite_teammate',
};

export const CHECKLIST_ITEM_COMPLETED_EVENTS: Record<string, string> = {
  connect_profiles: HeapUtils.events.CHECKLIST_ITEM_CONNECT_PROFILES_COMPLETED,
  first_post: HeapUtils.events.CHECKLIST_ITEM_FIRST_POST_COMPLETED,
  send_for_approval:
    HeapUtils.events.CHECKLIST_ITEM_SEND_FOR_APPROVAL_COMPLETED,
  invite_teammate: HeapUtils.events.CHECKLIST_ITEM_INVITE_TEAMMATE_COMPLETED,
};

export interface ChecklistCompletionState {
  completedIds: string[];
  isChecklistCompleted: boolean;
}

export interface ChecklistCompletionUpdate {
  state: ChecklistCompletionState;
  newlyCompletedIds: string[];
  isChecklistNewlyCompleted: boolean;
}

export const getChecklistCompletionUpdate = (
  previous: ChecklistCompletionState | null,
  doneIds: string[],
  allIds: string[],
): ChecklistCompletionUpdate => {
  const previousIds = previous?.completedIds ?? [];
  const completedIds = Array.from(new Set([...previousIds, ...doneIds]));
  const isAllCompleted =
    allIds.length > 0 && allIds.every((id) => completedIds.includes(id));

  if (!previous) {
    return {
      state: { completedIds, isChecklistCompleted: isAllCompleted },
      newlyCompletedIds: [],
      isChecklistNewlyCompleted: false,
    };
  }

  return {
    state: {
      completedIds,
      isChecklistCompleted: previous.isChecklistCompleted || isAllCompleted,
    },
    newlyCompletedIds: completedIds.filter((id) => !previousIds.includes(id)),
    isChecklistNewlyCompleted: !previous.isChecklistCompleted && isAllCompleted,
  };
};

export const getDaysSinceSignup = (regDate: string | null | undefined) => {
  if (!regDate) {
    return null;
  }

  const registeredAt = dayjs(regDate);

  return registeredAt.isValid() ? dayjs().diff(registeredAt, 'day') : null;
};
